module.exports = __webpack_public_path__ + "static/media/ic_logo_small.0469cfac.svg";